import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "196053b7-e958-4f64-871b-c174ae7f92d3",
  publicId: "5",
  name: "Reflection",
  body: [principle01, task01, task02],
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
};

export default lesson;
